$ = require 'jquery'
WindowSize = require 'lib/window-size'

$ ->
  WindowSize.calc()

  resize = null
  $(window).on 'resize', ->
    clearTimeout(resize)
    resize = setTimeout (-> WindowSize.calc()), 200
    return



// WEBPACK FOOTER //
// ./app/scripts/init/window-resize-watcher.coffee